import { LocalStorageError } from '@embed/errors';
import { uuidv4 } from '@embed/helpers';
import { pruneNilValues } from '@embed/store/tools/utils';
import cookies from '@src/utils/cookies';
const guestIdLocalStorageKey = '_fwnguid';
const guestIdCookieMaxDays = 60;
export const isExpired = (expiresAt) => !expiresAt || (expiresAt && Date.now() - Date.parse(expiresAt) > 0);
export const isValidGuestId = (guestId) => !!guestId && guestId !== 'null' && guestId !== 'undefined';
export const getGuestId = () => {
    try {
        // TODO fw.tv needs sessions stored in cookies to support sharing sessions
        // between subdomains, while fwn cannot rely on cookies and needs
        // localStorage. We should consider refactoring this into separate modules
        // @stefan: Do we need to remove localstorage strategy if fn only used by guest session
        //          on FWN widget?
        const idFromStorage = window.localStorage && window.localStorage.getItem(guestIdLocalStorageKey);
        const idFromCookie = cookies.get(guestIdLocalStorageKey);
        return idFromCookie || idFromStorage;
    }
    catch (error) {
        throw new LocalStorageError(`getGuestId: ${error}`);
    }
};
export const setGuestId = (newGuestId) => {
    try {
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + guestIdCookieMaxDays);
        cookies.set(guestIdLocalStorageKey, newGuestId, expireDate);
        window.localStorage &&
            window.localStorage.setItem(guestIdLocalStorageKey, newGuestId);
    }
    catch (error) {
        // Pass silently
    }
};
export const clearGuestId = () => {
    try {
        // @stefan: see comment in `getGuestId`
        window.localStorage &&
            window.localStorage.removeItem(guestIdLocalStorageKey);
        cookies.remove(guestIdLocalStorageKey);
    }
    catch (error) {
        // Pass silently
    }
};
let localGuestIdCached = null;
export const fetchGuestId = () => localGuestIdCached || getGuestId();
// Fetch GuestId from local storage or creates a new one.
// Returns promise.
export const fetchOrCreateGuestId = () => {
    return new Promise((resolve) => {
        try {
            const localGuestId = fetchGuestId();
            if (localGuestId) {
                if (isValidGuestId(localGuestId)) {
                    return resolve(localGuestId);
                }
                else {
                    clearGuestId();
                }
            }
            localGuestIdCached = uuidv4();
            setGuestId(localGuestIdCached);
            return resolve(localGuestIdCached);
        }
        catch (error) {
            if (error instanceof LocalStorageError) {
                if (!localGuestIdCached) {
                    localGuestIdCached = uuidv4();
                }
                return resolve(localGuestIdCached);
            }
            throw error;
        }
    });
};
export const parseSession = (s) => {
    var _a, _b, _c, _d, _e;
    if (!s) {
        return {};
    }
    const session = {
        guest_id: ((_a = s.session) === null || _a === void 0 ? void 0 : _a.guest_id) || (s === null || s === void 0 ? void 0 : s.guest_id),
        session_id: s.session_id || ((_b = s.session) === null || _b === void 0 ? void 0 : _b.id) || (s === null || s === void 0 ? void 0 : s.id),
        session_type: s.session_type || ((_c = s.session) === null || _c === void 0 ? void 0 : _c.type) || (s === null || s === void 0 ? void 0 : s.type),
    };
    // If explicit encoded user_id is found, use that.
    if (s._user_id) {
        session._user_id = s._user_id;
    }
    else {
        session.user_id = (_d = s.session) === null || _d === void 0 ? void 0 : _d.user_id;
    }
    // If explicit encoded visitor_id (user_id) is found, use that.
    if (s._visitor_id) {
        session._visitor_id = s._visitor_id;
    }
    else {
        session.visitor_id = (_e = s.session) === null || _e === void 0 ? void 0 : _e.visitor_id;
    }
    return pruneNilValues(session);
};
